import React, { useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import Table from "./Table";
import { Toast } from "primereact/toast";

const ConsutantMaster = (permissions: IPermissionProps) => {
  
  const toast = useRef<any>(null);
  return (
    <>
      <Table permissions={permissions} toast={toast}></Table>
      <Toast ref={toast} />
    </>
  );
};

export default ConsutantMaster;
